module.exports = __webpack_public_path__ + "img/w3_bil_light.667d3490.png";